<template>
  <div class="px-7 py-0 mt-3">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs7 mb-3 class="px-0 pb-0">
          <h3 class="darkblue--text breadcrumbs font-weight-700 fs-16 lh-16">
            SPENDING DETAIL
          </h3>
          <v-breadcrumbs
            class="px-0 subtitle-2 mt-0 pt-0 pb-0 breadcrumbs-items"
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mt-3" dark @click="downloadAll">
          <v-icon size="10px">mdi-download</v-icon>Download
        </v-btn>
      </v-layout>
    </v-container>

    <v-layout class="px-0 mt-4" v-if="submitable.toString() !== 'false'">
      <v-flex xs12>
        <v-card>
          <v-card-title class="primary titleDetail py-1 px-2 white--text">
            <span class="title pl-2">PROGRESS TRACKING</span>
            <v-spacer></v-spacer>
            <v-icon
              color="white"
              class="mr-2"
              id="refreshBudget"
              @click="getData()"
            >
              refresh
            </v-icon>
          </v-card-title>
          <v-card-text class="pt-5">
            <tracking-progress :item="approverList" class="py-1" />
            <tracking-progress
              v-if="approverList2.length > 0"
              :item="approverList2"
              class="py-1"
              :part="2"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout class="px-0 mt-4">
      <v-flex xs12 class="">
        <v-card>
          <v-card-title class="primary titleDetail py-1 px-2 white--text">
            <span class="title pl-2">SPENDING DETAIL</span>
            <v-spacer></v-spacer>
            <v-icon
              color="white"
              class="mr-2"
              id="refreshBudget"
              @click="getData()"
            >
              refresh
            </v-icon>
          </v-card-title>
          <ValidationObserver ref="obs">
            <v-card-text class="px-2 py-2">
              <!-- IO INFORMATION -->
              <io-information
                :item="item"
                :toEdit="toEdit"
                :showAdhoc="showAdhoc"
                :isActiveRevise="isActiveRevise"
              >
              </io-information>
              <!-- /IO INFORMATION -->

              <!-- FORM IO -->
              <v-flex xs9 class="pl-0 my-2" v-if="isEdit">
                <v-icon color="primary" class="bg-info mb-1 pl-2">edit</v-icon>
                <span class="pl-2 font-weight-medium subtitle-1 darkblue--text">
                  EDIT SPENDING
                </span>
              </v-flex>
              <v-layout row wrap class="px-5">
                <v-flex xs3 class="pr-3 mb-3">
                  <ValidationProvider
                    name="Product Hierarchy"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Product Hierarchy</label>
                    <v-autocomplete
                      id="productHierarchy"
                      dense
                      single-line
                      outlined
                      placeholder="Select Product"
                      :disabled="!isEdit || item.io_number ? true : false"
                      v-model="item.product"
                      required
                      :items="product_hierarchies"
                      item-text="material_desc"
                      return-object
                      :error-messages="errors"
                      autocomplete
                      hide-details
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs3 class="pr-3 mb-3">
                  <ValidationProvider
                    name="Cost Center"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Cost Center</label>
                    <v-autocomplete
                      id="costCenter"
                      single-line
                      outlined
                      :disabled="!isEdit || item.io_number ? true : false"
                      placeholder="Select Cost Center"
                      required
                      dense
                      v-model="item.taxonomy"
                      :items="taxonomies"
                      item-text="costCenter.desc"
                      return-object
                      :error-messages="errors"
                      autocomplete
                      @change="autofilledTaxonomy()"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs3 class="pr-3 mb-3">
                  <ValidationProvider
                    name="Working/Non Working"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Working/Non Working</label>
                    <v-select
                      id="costCenter"
                      dense
                      disabled
                      single-line
                      v-model="item.taxonomy.costCenter.type"
                      outlined
                      label="Select Working/Non Working"
                      required
                      item-text="name"
                      item-value="value"
                      :items="pillars"
                      :error-messages="errors"
                      hide-details
                    ></v-select>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs3 class="pr-3 mb-3">
                  <ValidationProvider
                    name="Method"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Method</label>
                    <v-select
                      id="costCenter"
                      dense
                      single-line
                      v-model="item.method"
                      outlined
                      label="Select Method"
                      required
                      :disabled="!isEdit || item.io_number ? true : false"
                      item-text="name"
                      item-value="value"
                      :items="methods"
                      :error-messages="errors"
                      hide-details
                    ></v-select>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs3 class="pr-3">
                  <ValidationProvider
                    name="Campaign"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Campaign</label>
                    <v-text-field
                      id="campaign"
                      dense
                      single-line
                      outlined
                      :disabled="!isEdit"
                      label="Campaign"
                      v-model="item.campaign"
                      required
                      :error-messages="errors"
                      hide-details
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs3 class="pr-3">
                  <label class="darkblue--text">Start</label>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        name="Start"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          dense
                          id="start"
                          v-model="item.start"
                          type="date"
                          :disabled="!isEdit"
                          placeholder="Picker in Menu"
                          prepend-inner-icon="event"
                          readonly
                          single-line
                          outlined
                          v-on="on"
                          :error-messages="errors"
                          hide-details
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      type="date"
                      v-model="item.start"
                      no-title
                      scrollable
                      id="spendingDate"
                      :min="minDate"
                      :max="maxDate"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 class="pr-3">
                  <label class="darkblue--text">End</label>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        name="End"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          dense
                          id="end"
                          v-model="item.end"
                          type="date"
                          :disabled="!isEdit"
                          placeholder="Picker in Menu"
                          prepend-inner-icon="event"
                          readonly
                          single-line
                          outlined
                          v-on="on"
                          :error-messages="errors"
                          hide-details
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      type="date"
                      v-model="item.end"
                      no-title
                      scrollable
                      id="spendingDate"
                      :min="minDate"
                      :max="maxDate"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 class="pr-3" v-if="isLoggedInAsSales">
                  <ValidationProvider
                    name="Investment Type"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Investment Type</label>
                    <v-select
                      dense
                      id="investment_type"
                      single-line
                      v-model="item.investment_type"
                      outlined
                      label="Select Investment Type"
                      required
                      item-text="name"
                      item-value="value"
                      :items="investment_types"
                      :error-messages="errors"
                      :disabled="!isEdit"
                      return-object
                    ></v-select>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs3 class="pr-3">
                  <ValidationProvider
                    name="Activity Description"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Activity Description</label>
                    <v-text-field
                      id="activityDesc"
                      dense
                      single-line
                      outlined
                      label="Activity Description"
                      :disabled="!isEdit"
                      v-model="item.activity_desc"
                      required
                      :error-messages="errors"
                      hide-details
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-col
                  class="pt-3 pl-0"
                  cols="12"
                  v-if="isLoggedInAsSales && loaded"
                >
                  <form-channel
                    :isDetail="!isEdit"
                    @saveChannel="saveChannel"
                    :account.sync="item.ioAccount"
                    :channel.sync="item.channels"
                  />
                </v-col>
                <v-col cols="6" class="pa-0"> </v-col>
                <v-col cols="6" class="pa-0">
                  <span
                    v-if="validationMessage != ''"
                    class="red--text fs-11"
                    >{{ validationMessage }}</span
                  >
                </v-col>
              </v-layout>
              <!-- /FORM IO -->

              <!-- FORM IO AMOUNT -->
              <v-layout row wrap class="px-5">
                <v-flex xs12>
                  <h3 class="black--text pb-2 pt-5">Amount</h3>
                </v-flex>
                <v-flex
                  xs3
                  v-for="(val, index) in item.amount"
                  :key="index"
                  :class="
                    index === 3 || index === 7 || index === 11 ? 'pr-0' : 'pr-3'
                  "
                >
                  <label class="darkblue--text">{{ val.month }}</label>
                  <v-currency-field
                    :id="val.month"
                    :placeholder="val.month"
                    single-line
                    v-model="val.value"
                    :item="item.amount"
                    outlined
                    :disabled="
                      val.month === 'Total' || !isEdit || monthCheck(val.month)
                    "
                  />
                  <!-- <v-text-field
                    :id="item.month"
                    single-line
                    outlined
                    v-currency="{
                      currency: 'IDR',
                      locale: 'id'
                    }"
                    :precision="0"
                    :value-as-integer="true"
                    :placeholder="item.month"
                    v-model="item.value"
                    required
                    @keyup="calculateTotal()"
                    :disabled="item.month === 'Total' || !isEdit"
                  ></v-text-field> -->
                </v-flex>
                <!-- <v-flex xs12>
                  <hr class="hr-line" />
                </v-flex> -->
              </v-layout>
              <!-- /FORM IO AMOUNT -->

              <!-- LIST SUPP DOCS -->
              <supp-docs
                :supportDoc="supportDoc"
                :downloadFile="downloadFile"
                :fileRemoved="fileRemoved"
                :loading3="loading3"
                :loading4="loading4"
                :isEdit="isEdit"
              >
              </supp-docs>
              <!-- /LIST SUPP DOCS -->

              <!-- FROM SUPP DOCS -->
              <v-layout row wrap v-if="isEdit" class="px-5">
                <v-flex xs12>
                  <h3 class="black--text">Supporting Docs</h3>
                  <span
                    >Only file types document .doc, .docx, .xls, .xlsx, .ppt,
                    .pptx, .pdf are allowed.</span
                  >
                </v-flex>
                <v-layout row wrap class="upload-docs">
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 1
                      <!-- A & P Investment Breakdown -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone1"
                      id="'dropzone1'"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'AP'))"
                      @vdropzone-complete="onComplete($event, (name = 'AP'))"
                    ></vue-dropzone>
                  </v-flex>
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 2
                      <!-- Cost estimation & detail production plan -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone2"
                      id="'dropzone2'"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'Cost Estimate'))"
                      @vdropzone-complete="
                        onComplete($event, (name = 'Cost Estimate'))
                      "
                    ></vue-dropzone>
                  </v-flex>
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 3
                      <!-- Proposal   -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone3"
                      id="'dropzone3'"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'Proposal'))"
                      @vdropzone-complete="
                        onComplete($event, (name = 'Proposal'))
                      "
                    ></vue-dropzone>
                  </v-flex>
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 4
                      <!-- Storyboard -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone4"
                      id="dropzone4"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'Storyboard'))"
                      @vdropzone-complete="
                        onComplete($event, (name = 'Storyboard'))
                      "
                    ></vue-dropzone>
                  </v-flex>
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 5
                      <!-- Storyboard -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone5"
                      id="dropzone5"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'Media Schedule'))"
                      @vdropzone-complete="
                        onComplete($event, (name = 'Media Schedule'))
                      "
                    ></vue-dropzone>
                  </v-flex>
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 6
                      <!-- Storyboard -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone6"
                      id="dropzone6"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'Agreement'))"
                      @vdropzone-complete="
                        onComplete($event, (name = 'Agreement'))
                      "
                    ></vue-dropzone>
                  </v-flex>
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 7
                      <!-- Storyboard -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone7"
                      id="dropzone7"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'ROI'))"
                      @vdropzone-complete="onComplete($event, (name = 'ROI'))"
                    ></vue-dropzone>
                  </v-flex>
                  <v-flex md3 pa-3>
                    <label class="darkblue--text">
                      Document 8
                      <!-- Storyboard -->
                    </label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone8"
                      id="dropzone8"
                      :options="dropzoneOptions"
                      @vdropzone-reset="fileRemoved((name = 'Distribution'))"
                      @vdropzone-complete="
                        onComplete($event, (name = 'Distribution'))
                      "
                    ></vue-dropzone>
                  </v-flex>
                  <!-- <v-flex xs12 px3>
                    <v-btn
                      class="secondblue text-capitalize f-13 white--text"
                      block
                      @click="uploadFile()"
                      :disabled="btnDisabled"
                    >
                      Upload
                    </v-btn>
                  </v-flex>-->
                </v-layout>
              </v-layout>
              <!-- /FROM SUPP DOCS -->
              <v-flex xs12 class="text-right px-2 mt-5 mb-8" v-if="isEdit">
                <v-btn
                  :disabled="isDisabledAdd"
                  color="primary"
                  @click="uploadFile()"
                  class="mb-3"
                >
                  Save
                </v-btn>
                <v-flex xs12>
                  <hr class="hr-line" />
                </v-flex>
              </v-flex>

              <!-- ROI -->
              <!-- <spending-report-roi
                :roiType="costElement"
                :ioCode="item.code"
                v-if="costElement !== ''"
              /> -->

              <v-flex
                xs12
                class="my-5 px-2"
                v-if="
                  costElement === 'PROMOTIONAL OBJECTS' || costElement === 'CRM'
                "
              >
                <hr class="hr-line" />
              </v-flex>
              <!-- Spending -->
              <v-layout row wrap class="mt-5 table-history">
                <img
                  src="@/assets/images/icon/file-text.png"
                  width="25px"
                  class="ml-4 mb-3"
                />
                <span class="pl-2 font-weight-medium subtitle-1 darkblue--text">
                  SPENDING HISTORY
                </span>
                <v-flex xs12 class="pt-1 px-5">
                  <!-- :sort-desc.sync="spendingDescending" -->
                  <v-data-table
                    class="nav-table"
                    dense
                    :headers="headersSpending"
                    :items="historySpendings"
                    :options.sync="spendingOptions"
                    :server-items-length="spendingItems"
                    :footer-props="{
                      itemsPerPageOptions: [10, 25, 50, 100]
                    }"
                  >
                    <template v-slot:body="{ items }">
                      <tbody v-if="items.length > 0">
                        <tr v-for="(item, index) in items" :key="index">
                          <td>{{ item.created_at || '-' }}</td>
                          <td>{{ item.user ? item.user.email : '-' }}</td>
                          <td v-if="item.initial_data">
                            {{
                              item.initial_data.io_number
                                ? item.initial_data.io_number
                                : '-'
                            }}
                          </td>
                          <td v-else>-</td>
                          <td>
                            {{
                              item.initial_data ? item.initial_data.code : ''
                            }}
                          </td>
                          <td class="text-capitalize">
                            {{ item.action || '-' }}
                          </td>
                          <td class="text-center">
                            <v-btn
                              x-small
                              class="ma-2"
                              text
                              icon
                              color="primary"
                              :disabled="item.action === 'create'"
                              @click="detailSpending(item)"
                            >
                              <v-icon x-small color="primary" class="bg-info">
                                info
                              </v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="6" class="text-center">
                            No data displayed
                          </td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:no-data>
                      <label color="primary">No data displayed</label>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <!-- Spending -->
              <v-flex xs12 class="my-5 px-2">
                <hr class="hr-line" />
              </v-flex>
              <!-- Approval -->
              <v-layout row wrap class="mt-5 table-history">
                <img
                  src="@/assets/images/icon/file-text.png"
                  width="25px"
                  class="ml-4 mb-3"
                />
                <span class="pl-2 font-weight-medium subtitle-1 darkblue--text">
                  APPROVAL HISTORY
                </span>
                <v-flex xs12 class="pt-1 px-5">
                  <!-- :sort-desc.sync="descending" -->
                  <v-data-table
                    class="nav-table"
                    dense
                    :headers="headers"
                    :items="historyApprovals"
                    :options.sync="options"
                    :server-items-length="totalItems"
                    :footer-props="{
                      itemsPerPageOptions: [10, 25, 50, 100]
                    }"
                  >
                    <template v-slot:body="{ items }">
                      <tbody v-if="items.length > 0">
                        <tr v-for="(item, index) in items" :key="index">
                          <td>{{ item.created_at || '-' }}</td>
                          <td>
                            {{ item.user ? item.user.email : '' }}
                          </td>
                          <td>{{ item.spending.code || '-' }}</td>
                          <td class="text-right">
                            <span v-if="item.change_data.amount">
                              {{
                                item.change_data.amount[12]
                                  ? idr(
                                      Number(item.change_data.amount[12].value)
                                    )
                                  : '-'
                              }}
                            </span>
                            <span v-else>-</span>
                          </td>
                          <td class="text-capitalize">
                            {{ item.action || '-' }}
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="5" class="text-center">
                            No data displayed
                          </td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:no-data>
                      <label color="primary">No data displayed</label>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <!-- Approval -->
            </v-card-text>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-2">
                <v-btn id="btn-back" dark color="red" @click="prevPage">
                  Back
                </v-btn>
              </v-flex>
            </v-card-actions>
          </ValidationObserver>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="detailDialog" max-width="60%">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="pa-0">Update Detail</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-flex xs12 class="pt-1 px-5">
                <template>
                  <v-simple-table
                    fixed-header
                    class="spending-table radius-table"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="f-14" rowspan="2">Update Type</th>
                          <th class="f-14" colspan="2">Update</th>
                        </tr>
                        <tr>
                          <th class="f-14">Before</th>
                          <th class="f-14">After</th>
                        </tr>
                      </thead>
                      <VuePerfectScrollbar
                        class="drawer-menu--scroll"
                        :settings="scrollSettings"
                      >
                        <tbody
                          v-if="spendingDetail.length > 0"
                          class="height-table"
                        >
                          <tr
                            v-for="(item, index) in spendingDetail"
                            :key="index"
                          >
                            <td class="f-14">
                              {{ item.field ? item.field : '-' }}
                            </td>
                            <td
                              v-if="typeof item.before === 'number'"
                              class="f-14"
                            >
                              {{ item.before ? idr(item.before) : '-' }}
                            </td>
                            <td v-else class="f-14">
                              {{ item.before }}
                            </td>
                            <td
                              v-if="typeof item.after === 'number'"
                              class="f-14"
                            >
                              {{ item.after ? idr(item.after) : '-' }}
                            </td>
                            <td v-else class="f-14">
                              {{ item.after }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="3" class="text-center">
                              No Data Displayed
                            </td>
                          </tr>
                        </tbody>
                      </VuePerfectScrollbar>
                    </template>
                  </v-simple-table>
                </template>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-6 px-11">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="detailDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import Swal from 'sweetalert2';
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vue2Dropzone from 'vue2-dropzone';
import ioInformation from '../../../components/fomSpending/information';
import supDocs from '../../../components/fomSpending/suppDocs';
import formChannel from '@/components/formChannel';
// import SpendingReportRoi from '@/components/SpendingReport/SpendingReportRoi';
import ProgressTracking from '@/components/SpendingReport/ProgressTrackingDynamic';

export default {
  components: {
    // SpendingReportRoi,
    'progress-dialog': ProgressDialog,
    vueDropzone: vue2Dropzone,
    VuePerfectScrollbar,
    'io-information': ioInformation,
    'supp-docs': supDocs,
    'form-channel': formChannel,
    'tracking-progress': ProgressTracking
  },
  mixins: [ACLMixin],
  props: ['id', 'submitable'],
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        timeout: 100000,
        thumbnailWidth: 150,
        acceptedFiles:
          '.xlsx, .xls, .XLS, .XLSX, .doc, .DOC, .docx, .DOCX, .pdf, .PDF, .ppt, .PPT, .pptx, .PPTX',
        maxFiles: 1,
        init: function() {
          this.on('addedfile', function() {
            if (this.files.length > 1) {
              this.removeFile(this.files[0]);
            }
          });
        },
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      files: [],
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsEdit: {
        maxScrollbarLength: 220
      },
      filter: '',
      filters: [],
      descending: true,
      sort: '',
      spendingDescending: true,
      spendingSort: '',
      totalItems: 0,
      spendingItems: 0,
      options: {
        itemsPerPage: 10,
        page: 1
      },
      spendingOptions: {
        itemsPerPage: 10,
        page: 1
      },
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'SPENDING REPORT',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'SPENDING DETAIL',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      headersSpending: [
        {
          text: 'Date',
          value: 'created_at',
          sortable: false
        },
        {
          text: 'Updated By',
          value: 'action',
          sortable: false
        },
        {
          text: 'IO Number',
          value: 'spending.code',
          sortable: false
        },
        {
          text: 'Code',
          value: 'user.name',
          sortable: false
        },
        {
          text: 'Status',
          value: 'user.name',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          sortable: false
        }
      ],
      headers: [
        {
          text: 'Date',
          value: 'created_at',
          sortable: false
        },
        {
          text: 'Created By',
          value: 'user.name',
          sortable: false
        },
        {
          text: 'Code',
          value: 'spending.code',
          sortable: false
        },
        {
          text: 'Total Amount (Full Year)',
          value: 'user.name',
          sortable: false
        },
        {
          text: 'Status',
          value: 'action',
          sortable: false
        }
      ],
      methods: [
        {
          name: 'Traditional',
          value: 'traditional'
        },
        {
          name: 'Digital',
          value: 'digital'
        }
      ],
      pillars: [
        {
          name: 'Working',
          value: 'working'
        },
        {
          name: 'Non Working',
          value: 'non working'
        }
      ],
      menu: false,
      menu2: false,
      loading3: false,
      loading4: false,
      isEdit: false,
      year: new Date(),
      item: {},
      historyBudgets: [],
      historyApprovals: [],
      historySpendings: [],
      spendingDetail: [],
      detailDialog: false,
      product_hierarchies: [],
      taxonomies: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      supportDoc: [],
      support_docs: {
        docs: [],
        name: [],
        file: []
      },
      statusEdit: '',
      showAdhoc: false,
      isActiveRevise: false,
      costElement: '',
      activeMonth: [],
      isDisabledAdd: false,
      validationMessage: '',
      channels: [],
      loaded: false,
      approverList: [],
      approverList2: [],
      investment_types: []
    };
  },
  computed: {
    isRevise() {
      if (
        this.isActiveRevise &&
        (this.item.status === 'approved' ||
          this.item.status === 'to modify' ||
          this.item.status === 'rejected')
      )
        return true;
      return false;
    },
    minDate() {
      let startYear = moment(this.item.year).format('YYYY');
      return startYear + '-01-01';
    },
    maxDate() {
      let endYear = moment(this.item.year).format('YYYY');
      return endYear + '-12-31';
    },
    validationAccount() {
      if (this.isLoggedInAsSales && this.item.ioAccount.length > 0) {
        return true;
      } else if (this.isLoggedInAsSales && this.item.ioAccount.length === 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    // descending() {
    //   this.historyApproval();
    // },
    'options.page'() {
      this.historyApproval();
    },
    'options.itemsPerPage'() {
      this.historyApproval();
    },
    // spendingDescending() {
    //   this.historySpending();
    // },
    'spendingOptions.page'() {
      this.historySpending();
    },
    'spendingOptions.itemsPerPage'() {
      this.historySpending();
    },
    'item.start'(val) {
      this.dateCheck(val, this.item.end);
    },
    'item.end'(val) {
      this.dateCheck(this.item.start, val);
    },
    activeMonth(val) {
      for (let i = 0; i < this.item.amount.length; i++) {
        if (!val.includes(this.item.amount[i].month)) {
          if (this.item.amount[i].month !== 'Total') {
            this.item.amount[i].value = 0;
          }
        }
      }
    }
  },
  async mounted() {
    localStorage.setItem('fromDetail', true);
    await this.getData();
    console.log(
      this.submitable.toString(),
      this.submitable.toString() !== 'false'
    );
    if (this.isLoggedInAsSales) {
      this.getInvestmentType();
    }
  },
  methods: {
    getInvestmentType() {
      this.$store
        .dispatch('investmentType/getAll', { paginate: false })
        .then(data => {
          if (data.code === 200) {
            this.investment_types = data.data;
          }
        });
    },
    async getProgressTracking() {
      this.progressDialogLoading = true;
      let param = {
        spending_id: this.id
      };
      return await this.$store
        .dispatch('spending/getProgressTracking', param)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            let tempData = data.data.map(item => {
              if (item.name.includes('Approval process on')) {
                item.name = item.name.substring(20);
              }
              return item;
            });
            // if (tempData.length > 5) {
            //   this.approverList = tempData.slice(0, 6);
            //   this.approverList2 = tempData.slice(6);
            //   for (var i = 0; i < this.approverList2.length - 1; i++) {
            //     this.approverList2[i].step = i + 1;
            //   }
            // } else {
            this.approverList = tempData;
            // }
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    saveChannel(item) {
      this.item.ioAccount = item.account;
      this.item.channel = item.channel;
    },
    monthCheck(val) {
      let isMonth = this.activeMonth.includes(val);
      return !isMonth;
    },
    dateCheck(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      let today = new Date();
      today.setHours(0, 0, 0);
      // if (startDate < today) {
      //   this.validationMessage =
      //     'You have entered an invalid date. Please check again.';
      //   this.isDisable = true;
      // } else {
      if (startDate > endDate) {
        this.validationMessage = 'Start Date must be earlier than End Date.';
        this.isDisabledAdd = true;
      } else {
        this.validationMessage = '';
        this.isDisabledAdd = false;
      }
      let setEndDate = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        this.daysInMonth(endDate.getMonth() + 1, endDate.getFullYear())
      );
      if (end.slice(5, 7) === '02') {
        setEndDate = new Date(setEndDate.setMonth(1));
      }
      this.activeMonth = [];
      let tempStart = moment(startDate);
      let tempEnd = moment(setEndDate);
      while (tempStart.isSameOrBefore(tempEnd)) {
        this.activeMonth.push(tempStart.format('MMMM'));
        tempStart.add(1, 'month');
      }
      // }
    },
    async getData() {
      if (this.submitable.toString() !== 'false') {
        await this.getProgressTracking();
      }
      await this.getDetail();
      await this.getProduct();
      if (this.isLoggedInAsSales) {
        await this.getChannel();
      }
      await this.getAdhoc();
      await this.reviseCheck();
      await this.getTaxonomy();
      await this.historySpending();
      await this.historyApproval();
    },
    async getDetail() {
      this.progressDialogLoading = true;
      let param = {
        spending_id: this.id
      };
      return await this.$store
        .dispatch('spending/detail', param)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.item = data.data.dataIO;
            if (this.item.taxonomy) {
              this.costElement = this.item.taxonomy.costElement.desc;
            } else {
              this.costElement = '-';
            }
            this.item.start = moment(this.item.start).format('YYYY-MM-DD');
            this.item.end = moment(this.item.end).format('YYYY-MM-DD');
            this.supportDoc = data.data.supportDoc;
            this.item.channel = '';
            this.loaded = true;
            // this.item.amount.map(item => {
            //   if (item.value === null) {
            //     item.value = 0;
            //   }
            //   return item;
            // });
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    getAdhoc() {
      return this.$store
        .dispatch('configuration/getAdhoc')
        .then(data => {
          if (data.code === 200) {
            this.showAdhoc = data.data.config;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    reviseCheck() {
      return this.$store
        .dispatch('configuration/checkActive')
        .then(data => {
          if (data.code === 200) {
            this.isActiveRevise = data.data.is_active;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    historySpending() {
      this.progressDialogLoading = true;
      if (this.spendingDescending) {
        this.spendingSort = 'desc';
      } else {
        this.spendingSort = 'asc';
      }
      const sort = this.spendingSort;
      let { page, itemsPerPage } = this.spendingOptions;
      return this.$store
        .dispatch('onePager/historySpending', {
          spending_id: this.id,
          sort,
          page,
          limit: itemsPerPage
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.historySpendings = data.data.result;
            this.spendingItems = Number(data.data.total_data);
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.spendingOptions = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    detailSpending(item) {
      this.progressDialogLoading = true;
      this.$store
        .dispatch('onePager/detailSpending', item.id)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.spendingDetail = data.data;
            this.detailDialog = true;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    historyApproval() {
      this.progressDialogLoading = true;
      // let params = {
      //   spending_id: this.id,
      // };
      // if (this.descending) {
      //   this.sort = 'desc';
      // } else {
      //   this.sort = 'asc';
      // }
      // const sort = this.sort;
      let options = this.copy(this.options);
      let { page, itemsPerPage } = options;
      return this.$store
        .dispatch('onePager/historyApproval', {
          spending_id: this.id,
          sort: 'desc',
          page,
          limit: itemsPerPage
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.historyApprovals = data.data.result;
            this.totalItems = Number(data.data.total_data);
            // const pageData = data.data.pagination.current_page;
            // const itemsPerPageData = data.data.pagination.per_page;
            this.options = {
              page: data.data.pagination.current_page,
              itemsPerPage: data.data.pagination.per_page
            };
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getProduct() {
      this.progressDialogLoading = true;
      if (this.item.brand_id) {
        let params = {
          brand_id: this.item.brand.id
        };
        return this.$store
          .dispatch('spending/getProduct', params)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              this.product_hierarchies = data.data;
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
          });
      } else {
        Swal.fire('Failed!', 'Brand is null', 'error');
      }
    },
    getChannel() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('channel/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.channels = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    getTaxonomy() {
      let limit = 10000;
      this.$store
        .dispatch('taxonomy/getAll', { limit })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.taxonomies = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    calculateTotal() {
      this.item.amount[12].value = 0;
      const totalAmount = this.item.amount
        .filter(item => item.month !== 'Total')
        .reduce((prevValue, item) => {
          prevValue = +prevValue + +item.value;
          return prevValue;
        }, 0);
      this.item.amount[12].value = totalAmount;
    },
    onComplete(file, name) {
      var fileType = file.upload.filename.split('.').pop();
      var fileTypes = [
        'xlsx',
        'xls',
        'XLS',
        'XLSX',
        'doc',
        'DOC',
        'docx',
        'DOCX',
        'pdf',
        'PDF',
        'ppt',
        'PPT',
        'pptx',
        'PPTX'
      ];
      if (fileTypes.includes(fileType)) {
        if (file.size <= 15000000) {
          this.support_docs.docs.push(file);
          this.support_docs.name.push(name);
          this.support_docs.file.push(file.upload.filename);
          if (this.support_docs.docs.length > 0) {
            this.btnDisabled = false;
          }
        } else {
          Swal.fire('Failed!', 'File size can not more than 15 mb', 'error');
        }
      } else {
        Swal.fire(
          'Failed!',
          'Only file types document .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf are allowed.',
          'error'
        );
      }
    },
    fileRemoved(name) {
      var indexFile = this.supportDoc.indexOf(name);
      var indexSupp = this.support_docs.name.indexOf(name);
      this.supportDoc.splice(indexFile, 1);
      this.support_docs.docs.splice(indexSupp, 1);
      this.support_docs.file.splice(indexSupp, 1);
      this.support_docs.name.splice(indexSupp, 1);
      if (this.supportDoc.length > 0) {
        this.btnDisabled = true;
      }
    },
    downloadFile(item) {
      let file = encodeURIComponent(item.file);
      window.open(
        this.baseUrl +
          '/v1/download/file?name=' +
          file +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    uploadFile() {
      if (this.support_docs.docs.length > 0) {
        this.progressDialogLoading = true;
        this.loading = true;
        let body = {
          io_code: this.item.code
        };
        const payload = new FormData();
        Object.keys(body).forEach(key => {
          payload.append(key, body[key]);
        });
        Array.from(this.support_docs.docs).forEach(file => {
          payload.append('docs[]', file);
        });
        this.$store
          .dispatch('spending/uploadDocs', payload)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.btnDisabled = true;
              const uploadedSupportDocs = data.data.map(item => ({
                io_code: item.ioCode,
                file: item.nameFile
              }));
              this.supportDoc = [...this.supportDoc, ...uploadedSupportDocs];

              Swal.fire('Success!', data.message.text_en, 'success');
              this.confirmEdit();
            } else {
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.data.error, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.confirmEdit();
      }
    },
    confirmEdit() {
      if (this.validationAccount) {
        Swal.fire({
          title: '',
          text: `Are you sure want to ${
            this.isRevise ? 'modify' : 'edit'
          } this spending?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.edit();
          }
        });
      } else {
        Swal.fire('Failed!', 'The Account field is required', 'error');
      }
    },
    edit() {
      this.progressDialogLoading = true;
      this.loading = true;

      let suppDocs = this.supportDoc.map(item => {
        return {
          io_code: this.item.code,
          name: item.name,
          file: item.file
        };
      });
      let body = {
        spending_id: this.item ? this.item.id : null,
        entity_id: this.item ? this.item.entity_id : null,
        brand_id: this.item.brand ? this.item.brand.id : null,
        house_id: this.item.house ? this.item.house.id : null,
        product_id: this.item.product ? this.item.product.id : null,
        budget_owner_id: this.item.budgetOwner
          ? this.item.budgetOwner.id
          : null,
        pic: this.item ? this.item.pic : null,
        code: this.item ? this.item.code : null,
        taxonomy_code: this.item.taxonomy ? this.item.taxonomy.code : null,
        pillars: this.item ? this.item.pillars : null,
        method: this.item ? this.item.method : null,
        campaign: this.item ? this.item.campaign : null,
        start: this.item ? this.item.start : null,
        end: this.item ? this.item.end : null,
        investment_type: this.item ? this.item.investment_type : null,
        activity_desc: this.item ? this.item.activity_desc : null,
        amount: this.item ? this.item.amount : null,
        support_docs: suppDocs,
        status: this.isRevise ? 'revise' : this.statusEdit,
        account:
          this.item.ioAccount.length > 0
            ? this.item.ioAccount.map(item => {
                return item.id ? item.id : item.account.id;
              })
            : null
      };
      this.$store
        .dispatch('spending/edit', body)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: 'Spending successfully edited',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            });
            // 'Success!', 'Spending successfully edited', 'success');
            this.$refs.myVueDropzone1.removeAllFiles();
            this.$refs.myVueDropzone2.removeAllFiles();
            this.$refs.myVueDropzone3.removeAllFiles();
            this.$refs.myVueDropzone4.removeAllFiles();
            this.$refs.myVueDropzone5.removeAllFiles();
            this.$refs.myVueDropzone6.removeAllFiles();
            this.$refs.myVueDropzone7.removeAllFiles();
            this.$refs.myVueDropzone8.removeAllFiles();
            this.support_docs = {
              docs: [],
              name: [],
              file: []
            };
            this.dialogEdit = false;
            this.getData();
            this.isEdit = false;
            // location.reload();
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    toEdit(status) {
      if (this.isActiveRevise)
        this.statusEdit = status === 'draft' ? 'edit' : 'revise';
      else this.statusEdit = 'edit';
      // this.statusEdit = status;
      this.isEdit = !this.isEdit;
    },
    downloadAll() {
      window.open(
        this.baseUrl +
          '/v1/logs/spending/' +
          this.id +
          '/report' +
          '?token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    prevPage() {
      return window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push({ name: 'dashboard' });
    }
  }
};
</script>
<style>
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid #d8d8d8;
}
.drawer-menu--scroll {
  max-height: 300px;
  overflow: auto;
}
.table-taxonomy::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}
.table-taxonomy::-webkit-scrollbar-thumb {
  background: #cccc !important;
}
.table-taxonomy::-webkit-scrollbar-thumb:window-inactive {
  background: #d8d8d8 !important;
}
.table-history th {
  background: #28a0f6 !important;
  height: 30px !important;
  color: #fff !important;
  text-align: center;
}
.table-history table th,
.table-history table td {
  white-space: nowrap !important;
  height: 30px !important;
}
/* width */
.table-history ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-history ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-history ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-history ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-history .theme--light.v-data-table thead tr th {
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 14px !important;
  line-height: 17px !important;
  letter-spacing: -0.02em !important;
  text-align: center !important;
  border-right: 1px solid #0000001f;
  height: 30px !important;
  color: #fff !important;
  background: #28a0f6 !important;
}
.table-history .theme--light.v-data-table tbody td {
  height: 30px !important;
  border-right: 0.5px solid rgba(0, 0, 0, 0.12);
  border-left: 0.5px solid rgba(0, 0, 0, 0.12);
}
.height-table {
  max-height: none !important;
}
</style>
